import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ListItemComponent = ({ label, route, icon, isMenuOpen = true, isSelected = false }) => {
  const navigate = useNavigate();

  const item = (
    <ListItem
      key={label}
      button
      onClick={() => navigate(route)}
      className={`${isSelected ? 'selected-item' : ''} sidebar-item`}
    >
      {<ListItemIcon>{icon}</ListItemIcon>}
      {isMenuOpen && <ListItemText primary={label} style={{ fontSize: '14px' }} />}
    </ListItem>
  );

  if (isMenuOpen) return item;

  return (
    <Tooltip title={label} placement='right' arrow>
      {item}
    </Tooltip>
  );
};
export default ListItemComponent;
